module.exports = "//static.hsappstatic.net/signup-ui-lego/static-1.12127/images/logos/apple.png"